import en from "./TranslationsEN";
import jp from "./TranslationsJP";

// jsonを結合する
var data = Object.assign(en, jp);

export { data };
